import WhatsAppButton from '@/components/WhatsAppButton'
import FadeIn from '@/components/FadeIn'

function FinalCta() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <FadeIn>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950 px-8 py-14 sm:px-16 sm:py-16 text-center shadow-2xl shadow-blue-950/20 border border-blue-400/10">
            <div
              className="absolute inset-0 pointer-events-none opacity-[0.15]"
              style={{
                backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(59,130,246,0.5), transparent 40%), radial-gradient(circle at 85% 85%, rgba(37,99,235,0.4), transparent 40%)',
              }}
            />
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white max-w-2xl mx-auto">
              Pronto para negociar seu ativo digital com quem entende do assunto?
            </h2>
            <p className="mt-4 text-white/60 max-w-xl mx-auto leading-relaxed">
              Fale com a nossa equipe agora mesmo e descubra como podemos ajudar na sua negociação, com sigilo e segurança do início ao fim.
            </p>
            <div className="mt-10 flex justify-center">
              <WhatsAppButton label="Fale conosco agora" variant="primary" size="lg" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  )
}

export default FinalCta
